/*
Infos about class inheritance
https://javascript.info/class-inheritance
*/
import DATABASE_HANDLER from "../database/databaseHandler";

export class DataObject {
    constructor(){
        this.local = {
            definitions: {
                databaseHandlerCall: ''
            },
            documentUpdates: {}
        }
    }

// setter
    setFromDataObject(dataObject){
        console.log ("setFromDataObject", dataObject);
        Object.keys(this).forEach( (key) => {
            if ( key !== 'local' ) {
                if ( dataObject[key] !== undefined ) {
                    if ( typeof dataObject[key] === 'object') {
                        this[key] = JSON.parse(JSON.stringify(dataObject[key]));
                    } else {
                        this[key] = dataObject[key];
                    }

                }
            }
        });
    }
// getter
    getDbObject(){
        let data = JSON.parse(JSON.stringify(this));
        delete data.id;
        delete data.local;
        return data;
    }
    getArrayFromMap(mapList){
        let list = [];
        Object.keys(mapList).forEach( (key) => {
            let element = mapList[key]
            element.id = key
            list.push(element);
        });
        return list;
    }
    getDBErrorText(error){
        switch (error.code) {
            case 'permission-denied':
                return 'Du bist nicht berechtigt diese Aktion durchzuführen, bitte wende dich an den Administrator!'
            default:
                return error.message;
        }
        //
    }
// service function
    changeDataTypeOfValue(value, inputId, calcObject){
        switch (calcObject.inputs[inputId].dataType) {
            case 'integer':
                if ( !Number.isFinite(value) ) {
                    value = value.replace(',', '.');
                    value = parseInt(value);
                }
                break;
            case 'double':
                if ( !Number.isFinite(value) ) {
                    value = value.replace(',', '.');
                    value = parseFloat(value);
                }
                break;
        }
        return value;
    }
    setDocumentUpdates(oldDBData){
        let newData = this.getDbObject();
        let changed = false;
        Object.keys(newData).forEach( (key) => {
            if ( newData[key] !== oldDBData[key] ) {
                this.local.documentUpdates[key] =  newData[key];
                changed = true;
            }
        });
        return changed;
    }
// checks
    noDatabaseHandlerCall(){
        if ( !this.local.definitions.databaseHandlerCall ) {
            console.error('ACHTUNG: local.definitions.databaseHandlerCall NICHT DEFINIERT');
            return true;
        }
        return false;
    }
// db updates
    async saveNew (type) {
        if ( this.noDatabaseHandlerCall() ) { return }
        //let databaseHandler = new DatabaseHandler();
        if ( type === 'document' ) {
            return await DATABASE_HANDLER.saveNew(this.local.definitions.databaseHandlerCall, this);
        } else { // type === 'parameter'
            return await DATABASE_HANDLER.saveNewKeyToDocument(this.local.definitions.databaseHandlerCall, this);
        }
    }
    async updateWithTransaction(call, safe){
        if ( !call && this.noDatabaseHandlerCall() ) { return }
        //let databaseHandler = new DatabaseHandler();
        let dbCall = call ? call : this.local.definitions.databaseHandlerCall;
        return await DATABASE_HANDLER.updateWithTransaction(dbCall, safe, this);
    }
    async updateWithTransactionFullCheck(call){
        if ( !call && this.noDatabaseHandlerCall() ) { return }
        //let databaseHandler = new DatabaseHandler();
        let dbCall = call ? call : this.local.definitions.databaseHandlerCall;
        return await DATABASE_HANDLER.updateWithTransactionFullCheck(dbCall, this);
    }
    async deleteWithTransaction(call, safe){
        if ( !call && this.noDatabaseHandlerCall() ) { return }
        //let databaseHandler = new DatabaseHandler();
        let dbCall = call ? call : this.local.definitions.databaseHandlerCall;
        return await DATABASE_HANDLER.deleteWithTransaction(dbCall, safe, this);
    }
    async saveEdited (call) {
        if ( !call && this.noDatabaseHandlerCall() ) { return }
        //let databaseHandler = new DatabaseHandler();
        let dbCall = call ? call : this.local.definitions.databaseHandlerCall;
        return await DATABASE_HANDLER.saveEdited(dbCall, this);
    }
    async deleteElementKey(){
        if ( this.noDatabaseHandlerCall() ) { return }
        //let databaseHandler = new DatabaseHandler();
        return await DATABASE_HANDLER.deleteElementKey(this.local.definitions.databaseHandlerCall, this);
    }

    async deleteDocument(call){
        if ( !call && this.noDatabaseHandlerCall() ) { return }
        //let databaseHandler = new DatabaseHandler();
        let dbCall = call ? call : this.local.definitions.databaseHandlerCall;
        return await DATABASE_HANDLER.deleteDocument(dbCall, this);
    }


}